import type { Destructor } from "~/tools/destructor";
import { onTimeout } from "~/tools/on-timeout";

/**
 * Executes a callback function when the browser is idle.
 * If the browser supports `requestAnimationFrame`, it will use that to schedule the callback.
 * Otherwise, it will fallback to using `setTimeout`.
 *
 * @param callback - The callback function to be executed when the browser is idle.
 * @returns A cleanup function that can be used to cancel the idle callback.
 */
export function onFrame(callback: VoidFunction): Destructor {
	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	if ("requestAnimationFrame" in window) {
		// biome-ignore lint/style/noRestrictedGlobals: encapsulation
		const idleId = window.requestAnimationFrame(callback);

		// biome-ignore lint/style/noRestrictedGlobals: encapsulation
		return () => window.cancelAnimationFrame(idleId);
	}

	return onTimeout(callback, 0);
}
